/**
 * DEPRECATED(miguel): This button toggle has been deprecated to allow
 * UI using this component to continue to function properly. The non
 * deprecated version of this uses the Blue theme colors instead of the
 * Green theme colors this deprecated version uses.
 *
 * A series of buttons from which a user can toggle between. The selected
 * button will have a toggled state, whereas the rest will be in a neutral
 * state.
 */
import {css, StyleSheet, type CSSProperties} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";
import {borderRadius} from "@khan/shared-styles";

type Props = {
    selected: string;
    options: Array<{
        value: string;
        label: string;
    }>;
    onToggle: (newState?: any) => void;
    buttonStyles?: CSSProperties;
};

class DeprecatedButtonToggle extends React.Component<Props> {
    render(): React.ReactNode {
        const {selected, options, onToggle, buttonStyles} = this.props;

        return (
            <div className={css(styles.buttonToggleContainer)}>
                {options.map((option) => {
                    const isSelected = option.value === selected;

                    return (
                        <button
                            key={option.value}
                            className={css(
                                styles.button,
                                theme.button,
                                isSelected && styles.selected,
                                isSelected && theme.selected,
                                buttonStyles,
                            )}
                            onClick={(e) => onToggle(option.value)}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        );
    }
}

// Standard height of buttons.
const inputHeight = 40;

const theme = StyleSheet.create({
    button: {
        backgroundColor: color.white,
        borderColor: color.offBlack16,
        color: color.blue,

        ":first-child": {
            borderLeftColor: color.offBlack16,
        },
        ":last-child": {
            borderRightColor: color.offBlack16,
        },
        ":hover": {
            backgroundColor: color.blue,
            borderColor: color.blue,
            color: color.white,
        },
    },
    selected: {
        backgroundColor: color.blue,
        borderColor: color.blue,
        color: color.white,
        ":first-child": {
            borderLeftColor: color.blue,
        },
        ":last-child": {
            borderRightColor: color.blue,
        },
        ":hover": {
            color: color.white,
        },
    },
});

const styles = StyleSheet.create({
    buttonToggleContainer: {
        display: "flex",
        flexDirection: "row",
        marginTop: 4,
        marginBottom: 18,
        height: inputHeight,
    },
    button: {
        flexGrow: 1,
        textAlign: "center",
        fontSize: 15,
        fontWeight: 600,
        padding: 0,
        margin: 0,

        borderWidth: "1px",
        borderStyle: "solid",

        cursor: "pointer",
        borderLeft: "none",
        borderRight: "none",

        ":first-child": {
            borderRadius: `${borderRadius}px 0 0 ${borderRadius}px`,
            borderLeftWidth: "1px",
            borderLeftStyle: "solid",
            borderRight: "none",
        },

        ":last-child": {
            borderRadius: `0 ${borderRadius}px ${borderRadius}px 0`,
            borderLeft: "none",
            borderRightWidth: "1px",
            borderRightStyle: "solid",
        },

        ":focus": {
            // Makes outline on focus appear above the neighboring buttons.
            position: "relative",
        },
    },
    selected: {
        ":first-child": {
            borderLeft: "none",
        },

        ":last-child": {
            borderRight: "none",
        },
    },
});

export default DeprecatedButtonToggle;
